import { FormControl, FormHelperText, TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import React from 'react';
import { createSelector } from 'reselect';
import lodash from 'lodash';
import { IPumpingStationMotorType } from '../../../../@types/model/masterData/pumpingStation/motorType';
import { IRootState } from '../../../../@types/redux';
import { connect } from 'react-redux';
import MasterDataPumpingStationMotorTypeFunctions from '../../../../store/masterData/pumpingStation/motorType/functions';

interface IPumpingStationMotorTypeSelectorProps {
    value : string;
    disabled ?: boolean;
    className ?: string;
    required ?: boolean;
    onChange : (value : string) => void;

    isLoading : boolean;
    motorTypes : Array<IPumpingStationMotorType>;
}

interface IPumpingStationMotorTypeSelectorState { }

class PumpingStationMotorTypeSelectorComponent extends React.Component<IPumpingStationMotorTypeSelectorProps, IPumpingStationMotorTypeSelectorState> {
    constructor(props : IPumpingStationMotorTypeSelectorProps) {
        super(props);

        this.state = {};
    }

    public componentDidMount() {
        MasterDataPumpingStationMotorTypeFunctions.load();
    }

    private readonly onChange = (event : React.ChangeEvent<unknown>, value : {
        label : string;
        value : string;
    } | null | undefined) => {
        this.props.onChange(value?.value ?? '');
    };

    private readonly getData = (state : IPumpingStationMotorTypeSelectorState, props : IPumpingStationMotorTypeSelectorProps) => props.motorTypes;
    private readonly getValue = (state : IPumpingStationMotorTypeSelectorState, props : IPumpingStationMotorTypeSelectorProps) => props.value;
    private readonly getRequired = (state : IPumpingStationMotorTypeSelectorState, props : IPumpingStationMotorTypeSelectorProps) => props.required;

    private readonly getMotorTypes = createSelector([
        this.getData,
    ], (motorTypes) => motorTypes.filter(x => x.isActive).map(x => x.name).sort());

    private readonly getMotorTypesForDropdown = createSelector([ 
        this.getRequired, this.getMotorTypes,
    ], (required, motorTypes) => {
        
        const dropdownData = lodash.map(motorTypes, (element) => ({ label: element, value: element }));
        
        if (!required) {
            dropdownData.unshift({
                label: 'ALL',
                value: '',
            });
        }

        return dropdownData;
    });

    private readonly getSelectedValue = createSelector([ 
        this.getValue, this.getRequired, this.getMotorTypes,
    ], (value, required, motorTypes) => {
        if (value) {
            const motorType = motorTypes.find(element => element === value);

            if (motorType) {
                return { label: motorType, value: motorType };
            } else {
                return { label: value, value };
            }
        }

        if (!value && !required) {
            return {
                label: 'ALL',
                value: '',
            };
        }

        return null;
    });

    public readonly render = () => {
        const { required, className, disabled } = this.props;

        const dropdownData = this.getMotorTypesForDropdown(this.state, this.props);

        const value = this.getSelectedValue(this.state, this.props);

        return (
            <FormControl margin={'normal'} fullWidth className={className} disabled={disabled} error={required && !value}>
                <Autocomplete 
                    id={'motorType'}
                    options={dropdownData}
                    value={value}
                    getOptionSelected={(option, val) => option.value === val.value}
                    getOptionLabel={option => option.label}
                    onChange={this.onChange}
                    disableClearable={required}
                    openOnFocus
                    renderInput={params => <TextField error={required && !value} {...params} fullWidth label={'Motor Type'} />}
                />
                {
                    required && !value &&
                    <FormHelperText error>Required</FormHelperText>
                }
            </FormControl>
        );
    };
}

const mapStateToProps = (state : IRootState) => {
    return { 
        isLoading: state.masterData.pumpingStation.motorType.isLoading,
        motorTypes: state.masterData.pumpingStation.motorType.motorTypes,
    };
};

const PumpingStationMotorTypeSelector = connect(
    mapStateToProps,
)(PumpingStationMotorTypeSelectorComponent);

export default PumpingStationMotorTypeSelector;